import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getProgress} from '../../services/getProgress';
import {useHostName} from 'presentation/hooks';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {useShowFacialBiometric} from 'presentation/pages/private/hooks/useShowFacialBiometric';

export function useGetProgressQuery() {
	const {isGndiSaoPaulo} = useHostName();
	const {accesses, isHolder, odontoOnly, canChangeAddress} = useAccountInformation();
	const showBankData = accesses.refund && isHolder && !odontoOnly && isGndiSaoPaulo;
	const showFacialBiometric = useShowFacialBiometric();

	return useQuery({
		queryKey: [
			QUERY_KEYS.PROGRESS_PROFILE,
			showBankData,
			canChangeAddress,
			showFacialBiometric,
		],
		queryFn: async ({signal}) =>
			getProgress({
				signal,
				isBeneficiaryBank: showBankData,
				isAddress: canChangeAddress,
				isFacialBiometry: showFacialBiometric,
			}),
		enabled: false,
		retry: 2,
	});
}
